// جزئیات ارجاع به ناظر (tblControlContractorRequestDetail) — مودال از داخل رسیدگی نهایی
import React, { useState, useEffect, useCallback } from 'react';
import { ui } from '../../components/ListPage';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFa   = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
const fmtNum = n => (n ? Number(n).toLocaleString('fa-IR') : '•');

const API = (path, opts = {}) => fetch(`/api/contract${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

const EMPTY = { visor_id: 0, visor: '', refering_date: '', visor_letter_no: '', visor_letter_date: '', visor_request_amount: '', remark: '' };

function Lookup({ label, value, endpoint, onPick }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const search = async (text) => { setQ(text); const j = await API(`${endpoint}?q=${encodeURIComponent(text)}`); if (j.ok) { setRows(j.rows); setOpen(true); } };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, position: 'relative' }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value || q} onFocus={() => search(q)} onChange={e => search(e.target.value)} placeholder="جستجو..." style={ui.input} />
      {value && <button onClick={() => { onPick({ id: 0, display: '' }); setQ(''); }}
        style={{ position: 'absolute', left: '6px', top: '30px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#c62828', fontSize: '14px' }}>✕</button>}
      {open && rows.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', right: 0, left: 0, background: '#fff', border: '1px solid #e0e0e0',
          borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 1200, maxHeight: '220px', overflowY: 'auto', marginTop: '2px' }}>
          {rows.map(r => (
            <div key={r.id} onClick={() => { onPick(r); setOpen(false); setQ(''); }}
              style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '1px solid #f0f0f0' }}
              onMouseEnter={e => e.currentTarget.style.background = '#e8f0fe'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>{r.display}</div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function ControlRequestDetail({ ccrId, contractTitle, onClose }) {
  // دکمه‌های فرم FRMCONTROLCONTRACTORREQUEST — دیدن = دسترسی
  const vbf = useFormButtons('FRMCONTROLCONTRACTORREQUEST', ["BTNSENDTOVISOR","BTNOK"]);
  const [data, setData]         = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading]   = useState(false);
  const [modal, setModal]       = useState(null);
  const [form, setForm]         = useState(EMPTY);
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [toast, setToast]       = useState('');

  const showToast = m => { setToast(m); setTimeout(() => setToast(''), 2500); };

  const load = useCallback(async () => {
    setLoading(true); setError(''); setSelected(null);
    const j = await API(`/controls/${ccrId}/details/`);
    setLoading(false);
    if (j.ok) setData(j.data); else setError(j.msg);
  }, [ccrId]);

  useEffect(() => { load(); }, [load]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const openNew  = () => { if (!vbf.can('BTNSENDTOVISOR')) return; setForm(EMPTY); setError(''); setModal('new'); };
  const openEdit = () => { if (!vbf.can('BTNSENDTOVISOR')) return; if (!selected) return; setForm({ ...EMPTY, ...selected }); setError(''); setModal('edit'); };
  const openDel  = () => { if (!vbf.can('BTNSENDTOVISOR')) return; if (selected) setModal('delete'); };

  const save = async () => {
    setSaving(true); setError('');
    const j = modal === 'new'
      ? await API(`/controls/${ccrId}/details/create/`, { method: 'POST', body: JSON.stringify(form) })
      : await API(`/controls/${ccrId}/details/${selected.id}/update/`, { method: 'PUT', body: JSON.stringify(form) });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast(j.msg); load(); }
    else setError(j.msg);
  };

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/controls/${ccrId}/details/${selected.id}/delete/`, { method: 'DELETE' });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('حذف شد'); load(); }
    else { setError(j.msg); setModal(null); }
  };

  return (
    <div style={ui.overlay} onClick={onClose}>
      <div style={{ ...ui.modal, maxWidth: '920px', width: '96%', height: '82vh' }} onClick={e => e.stopPropagation()}>
        <div style={ui.mHeader}>
          <div style={ui.mTitle}>ارجاع به ناظر — {contractTitle}</div>
          <button onClick={onClose} style={ui.closeBtn}>✕</button>
        </div>

        <div style={{ display: 'flex', gap: '8px', padding: '12px 18px', borderBottom: '1px solid #f0f2f7', flexWrap: 'wrap' }}>
          {vbf.can('BTNSENDTOVISOR') && <button onClick={openNew} style={ui.btnNew}>＋ ارجاع جدید</button>}
          {vbf.can('BTNSENDTOVISOR') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✎ ویرایش پاسخ</button>}
          {vbf.can('BTNSENDTOVISOR') && <button onClick={openDel} disabled={!selected} style={{ ...ui.btnDel, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✕ حذف</button>}
          {loading && <span style={{ alignSelf: 'center' }}>⏳</span>}
          {!loading && <div style={{ ...ui.countBadge, alignSelf: 'center' }}>{toFa(data.length)} مورد</div>}
        </div>

        {error && !modal && <div style={{ ...ui.errBox, margin: '10px 18px' }}>⚠️ {error}</div>}

        <div style={{ flex: 1, overflowY: 'auto', margin: '0 18px 12px', borderRadius: '10px', border: '1px solid #eee' }}>
          <table style={{ ...ui.table, tableLayout: 'auto' }}>
            <thead style={{ position: 'sticky', top: 0, zIndex: 5 }}>
              <tr>{['ناظر', 'تاریخ ارجاع', 'شماره پاسخ', 'تاریخ پاسخ', 'مبلغ تایید شده', 'توضیحات ناظر'].map((h, i) => <th key={i} style={ui.th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {data.map((r, i) => {
                const sel = selected?.id === r.id;
                const bg  = sel ? '#1a2f50' : i % 2 === 0 ? '#fff' : '#fdf6e3';
                const tc  = sel ? '#fff' : '#111';
                return (
                  <tr key={r.id} style={{ background: bg, cursor: 'pointer' }}
                    onClick={() => setSelected(sel ? null : r)} onDoubleClick={() => { setSelected(r); setTimeout(openEdit, 0); }}
                    onMouseEnter={e => { if (!sel) e.currentTarget.style.background = '#e8f0fe'; }}
                    onMouseLeave={e => { if (!sel) e.currentTarget.style.background = bg; }}>
                    <td style={{ ...ui.td, textAlign: 'right', color: tc }}>{r.visor || '•'}</td>
                    <td style={{ ...ui.td, fontFamily: 'monospace', fontSize: '11px', color: tc }}>{r.refering_date || '•'}</td>
                    <td style={{ ...ui.td, color: tc }}>{toFa(r.visor_letter_no) || '•'}</td>
                    <td style={{ ...ui.td, fontFamily: 'monospace', fontSize: '11px', color: tc }}>{r.visor_letter_date || '•'}</td>
                    <td style={{ ...ui.tdNum, color: sel ? '#fff' : '#1b5e20' }}>{fmtNum(r.visor_request_amount)}</td>
                    <td style={{ ...ui.td, textAlign: 'right', color: tc }}>{r.remark || '•'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {!loading && data.length === 0 && <div style={ui.empty}>📭 ارجاعی ثبت نشده است</div>}
        </div>
      </div>

      {(modal === 'new' || modal === 'edit') && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '620px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal === 'new' ? '＋ ارجاع به ناظر' : '✎ ویرایش پاسخ ناظر'}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}
              <div style={ui.row}>
                <Lookup label="ناظر" value={form.visor} endpoint="/controls/lookup/people/"
                  onPick={r => setForm(f => ({ ...f, visor_id: r.id, visor: r.display }))} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', width: '150px' }}>
                  <label style={ui.mlabel}>تاریخ ارجاع</label>
                  <JalaliDatePicker value={form.refering_date} onChange={v => F('refering_date', v)} placeholder="تاریخ ارجاع" />
                </div>
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>شماره پاسخ ناظر</label>
                  <input value={form.visor_letter_no} onChange={e => F('visor_letter_no', e.target.value)} style={ui.input} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>تاریخ پاسخ ناظر</label>
                  <JalaliDatePicker value={form.visor_letter_date} onChange={v => F('visor_letter_date', v)} placeholder="تاریخ پاسخ" />
                </div>
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>مبلغ تایید شده (ریال)</label>
                  <input type="number" value={form.visor_request_amount} onChange={e => F('visor_request_amount', e.target.value)} style={ui.input} />
                </div>
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>توضیحات ناظر</label>
                  <input value={form.remark} onChange={e => F('remark', e.target.value)} style={ui.input} />
                </div>
              </div>
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal === 'delete' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '420px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={ui.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign: 'center', padding: '24px' }}>
              <div style={{ fontSize: '30px', marginBottom: '8px' }}>🗑️</div>
              ارجاع به {selected?.visor}
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setModal(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNSENDTOVISOR') && <button onClick={doDelete} disabled={saving} style={{ ...ui.btnSave, background: '#b71c1c' }}>{saving ? '⏳...' : 'بله، حذف'}</button>}
            </div>
          </div>
        </div>
      )}

      {toast && <div style={ui.toast}>{toast}</div>}
    </div>
  );
}
